<template>
  <section class="blog-box">
    <!-- 通过估算已知每个blog所对应的骨架行数大约为7, 所以骨架总行数应该为blogs.length*7 -->
    <el-skeleton :loading="loading" :rows="pagingParams.pageSize*7" animated>
      <div class="blog" :key="b.id" v-for="b in blogs">
        <div class="title-box">
          <span class="title"><a class="clear-a" :href="`/blog/${b.id}`">{{b.title}}</a></span>
        </div>
        <div class="profile-box">
          <el-space :size="7" spacer="|">
            <span class="catalog">
              <el-tag size="mini"><i class="el-icon-folder" /> {{b.category.categoryName}}</el-tag>
            </span>
            <span class="tags">
              <el-tag size="mini" class="tag" :type="randomTagType()" :key="t.id" v-for="t in b.tags">
                <i class="el-icon-collection-tag" />
                <span>{{t.tagName}}</span>
              </el-tag>
            </span>
            <span class="time">{{b.gmtCreate}}</span>
          </el-space>
        </div>
        <div class="abstract-box">
          <span class="abstract">
            {{b.digest}}
          </span>
        </div>
        <div class="tools-box">
          <span class="tool like"><i class="el-icon-sunny" /><span class="t"> {{b.likeCount || 0}} 喜欢</span></span>
          <span class="tool comment"><i class="el-icon-chat-square" /><span class="t"> {{b.commentCount || 0}} 评论</span></span>
          <span class="tool view"><i class="el-icon-view" /><span class="t"> {{b.viewCount || 0}} 浏览</span>
          </span>
        </div>
      </div>
      <!-- <div class="blog" :key="b.id" v-for="b in blogs" > 
        <div class="title-box">
          <span class="title"><a class="clear-a" :href="`/blog-detail/{b.id}`">{{b.title}}</a></span>
        </div>
        <div class="profile-box">
          <span class="catalog">
            <el-tag size="mini"><i class="el-icon-folder" /> {{b.category.categoryName}}</el-tag>
          </span> |
          <span class="tags" :key="t.id" v-for="t in b.tags">
            <el-tag size="mini" class="tag" type="info"><i class="el-icon-collection-tag" /><span>Spring</span></el-tag>
          </span> |
          <span class="time">20201-005-13 14:32</span>
        </div>
        <div class="abstract-box">
          <span class="abstract">
            鲁迅先生，一位敢用“笔”来战斗的勇士，他写尽了世间最为真实一面，也为多数人驱散了头顶上的阴霾。 有人曾评价鲁迅先生为敢说“真话”的人。他的话语鲁迅先生，一位敢用“笔”来战斗的勇士，
            他写尽了世间最为真实一面，也为多数人驱散了头顶上的阴霾。他的话语...
            鲁迅先生，一位敢用“笔”来战斗的勇士，他写尽了世间最为真实一面，也为多数人驱散了头顶上的阴霾。 有人曾评价鲁迅先生为敢说“真话”的人。他的话语鲁迅先生，一位敢用“笔”来战斗的勇士，
            他写尽了世间最为真实一面，也为多数人驱散了头顶上的阴霾。他的话语...
          </span>
        </div>
        <div class="tools-box">
          <span class="tool like"><i class="el-icon-sunny" /><span class="t"> 129 喜欢</span></span>
          <span class="tool comment"><i class="el-icon-chat-square" /><span class="t"> 99 评论</span></span>
          <span class="tool view"><i class="el-icon-view" /><span class="t"> 12392178 浏览</span>
          </span>
        </div>
      </div> -->
      <section class="paging-box">
        <el-pagination background layout="prev, pager, next" :current-page="pagingParams.currentPage" :page-size="pagingParams.pageSize" :total="pagingParams.total" @current-change="currentPageChange" />
      </section>
    </el-skeleton>
  </section>
</template>

<script lang="ts">
import { defineComponent, reactive, toRefs, useContext } from 'vue'
import { useLog } from '@/hooks'
import { getRandomFromArr } from '@/util/GlobalUtil'

export default defineComponent({
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: true,
    },
    blogs: {
      type: Array,
      required: true,
      default: () => [],
    },
    pagingParams: {
      type: Object,
      rquired: true,
      default: () => ({
        pageSize: 10,
        currentPage: 1,
        total: 100,
      }),
    },
  },
  setup() {
    // eslint-disable-next-line
    const l = useLog()
    const { emit } = useContext()
    const state = reactive({})
    const randomTagType = () =>
      getRandomFromArr(['info', '', 'danger', 'warning', 'success'])

    const currentPageChange = (newCurrentPage: number) =>
      emit('currentPageChange', newCurrentPage)

    return {
      ...toRefs(state),
      randomTagType,
      currentPageChange,
    }
  },
})
</script>

<style lang="scss" scoped>
.blog-box {
  // border: 1px solid orange;
  flex: 1.8;

  // 一条博客css
  .blog {
    // border: 1px solid gray;
    border-bottom: 1px solid lightgray;
    padding: 30px 20px 30px 20px;

    transition: all 0.5s;

    &:hover {
      box-shadow: 0 0px 28px 0 rgba(0, 0, 0, 0.18);
      border-radius: 15px;
    }

    > div {
      margin-bottom: 10px;
    }

    .title-box {
      .title {
        font-size: 1.5rem;
        a {
          color: black;
          cursor: pointer;
          transition: all 0.3s;
          &:hover {
            color: $theme-color;
          }
        }
      }
    }

    .profile-box {
      color: $gray-font;
      .tags {
        .tag:not(:first-child) {
          margin-left: 5px;
        }
      }
      .time {
        font-size: 0.8rem;
      }
    }

    .abstract-box {
      // height: 54px;
      max-height: 54px;
      // border: 1px solid red;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;

      .abstract {
        font-size: 0.8rem;
        color: #909399;
      }
    }

    .tools-box {
      .tool {
        & + .tool {
          margin-left: 20px;
        }
        .t {
          font-size: 0.75rem;
          color: #909399;
          margin-left: 3px;
        }
      }
    }
  }
}
.paging-box {
  margin-top: 20px;
  text-align: center;
}
</style>